import Grid from '@mui/material/Grid';
import type { JSX } from 'react';
import { ActionButton, type ActionButtonProps } from './ActionButton.tsx';
import type { HeaderActionsProps } from './HeaderActions.tsx';

const HeaderBulkActions = (props: HeaderActionsProps): JSX.Element => {
  const { actions } = props;

  return (
    <Grid
      container
      spacing={1}
      sx={{
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {actions.map((action: ActionButtonProps, index) => (
        <ActionButton {...action} key={index} />
      ))}
    </Grid>
  );
};

export { HeaderBulkActions };
